export default __webpack_public_path__ + "static/media/Aplicaçãologo.b27f13eb.png";